import { inferAdditionalFields } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

const baseURL = import.meta.env.VITE_BETTER_AUTH_URL

if (!baseURL) {
  throw new Error('Missing Better Auth environment variable: VITE_BETTER_AUTH_URL must be set')
}

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: { credentials: 'include' },
  plugins: [
    inferAdditionalFields({
      user: {
        // Server-owned columns (input: false) — mirror the server's flags so the
        // client never treats them as sign-up inputs.
        language: { type: 'string', input: false },
        subscription_status: { type: 'string', input: false },
        trial_ends_at: { type: 'date', input: false },
        stripe_customer_id: { type: 'string', input: false },
        stripe_subscription_id: { type: 'string', input: false },
        subscription_current_period_end: { type: 'date', input: false },
        email_sync_lookback_days: { type: 'number', input: false },
        config: { type: 'json', input: false },
        role: { type: 'string', input: false },
        last_daily_brief_sent_at: { type: 'date', input: false },
        deletion_requested_at: { type: 'date', input: false },
        deletion_status: { type: 'string', input: false },
        // Optional recovery address a standalone user sets at signup; where
        // password-reset links are sent. `input: true` so signUp.email can set it.
        recovery_email: { type: 'string', required: false, input: true },
        // Browser-provided IANA timezone used to seed Stalwart calendar settings.
        calendar_time_zone: { type: 'string', required: false, input: true },
      },
    }),
  ],
})

export const { useSession } = authClient

// Origin of the auth service, for the standalone-signup endpoints that live
// outside Better Auth's `/api/auth` namespace (availability + mailbox status).
// `baseURL` may or may not include a path, so normalise to the bare origin.
export const authServiceOrigin = new URL(baseURL).origin
